export function convertText(txt : string) {
    return (txt.trim().replace(' ','-').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))
}